// extracted by mini-css-extract-plugin
export const container = "serviceicon-module--container--2Bbdi";
export const icon = "serviceicon-module--icon--2VTe6";
export const title = "serviceicon-module--title--1RBg8";
export const description = "serviceicon-module--description--__EVF";